// Module
var code = "<div ref=\"loginContainer\" class=\"flex flex-column justify-content-center align-center\">\n\n</div>";
// Exports
module.exports = code;